
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  AlertAction,
  AlertGetter,
  AlertState,
  AlertType
} from "@/components/alert/types";
import { Namespace } from "@/store/types";

@Component({})
export default class Alert extends Vue {
  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  alertReset!: (alertData: AlertState) => void;

  @Getter(AlertGetter.GetShow, { namespace: Namespace.Alert })
  alertShow!: boolean;

  @Getter(AlertGetter.GetMessage, { namespace: Namespace.Alert })
  alertMessage!: string;

  @Getter(AlertGetter.GetAlertType, { namespace: Namespace.Alert })
  alertType!: AlertType;

  @Watch("alertShow")
  handleShow(): void {
    if (this.alertShow) {
      setTimeout(() => {
        this.alertReset({
          show: false
        });
      }, 2500);
    }
  }
}
